import type { ComputedRef, InjectionKey } from "vue";
import { computed, hasInjectionContext, inject } from "vue";
import { useAuthStore } from "../AuthStore/useAuthStore";

export const AI_TRANSLATION_MODULE_KEY: InjectionKey<ComputedRef<boolean>> = Symbol("aiTranslationModule");

/**
 * Web gates AI translations behind the staff-only `enableAiTranslationModule` preference by providing
 * `useAiTranslationModulePreference()` under `AI_TRANSLATION_MODULE_KEY`. Apps that do not provide it (CMS)
 * always show AI translations.
 */
export function useAiTranslationModuleEnabled(): ComputedRef<boolean> {
  if (!hasInjectionContext()) {
    return computed(() => true);
  }
  return inject(AI_TRANSLATION_MODULE_KEY, () => computed(() => true), true);
}

export function useAiTranslationModulePreference(): ComputedRef<boolean> {
  const { userPreferences } = useAuthStore();
  return computed(() => userPreferences.value?.enableAiTranslationModule === true);
}
